module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cGF0aCBkPSJNMTUgMTh2LTJhNCA0IDAgMCAwLTQtNEg0YTQgNCAwIDAgMC00IDR2MiIvPg0KICAgICAgICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSI0IiByPSI0Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik0xOSA1djZNMjIgOGgtNiIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user-plus.svg
// module id = 53Vg
// module chunks = 1